import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { InputField } from 'src/components';
import { setFromErrors } from 'src/helpers';
import { useGetInstituteWiseItmcTeamInfoQuery, useItmcTeamCreateMutation } from 'src/rtk/features/instituteInspection/institutueInspectionApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSupervisorsByInstituteQuery } from 'src/rtk/features/trainingRecord/trainingRecordlApi';
import * as Yup from 'yup';

const initialValues = {
    itmc_team_id: '',
    committee_name: '',
    institute_id: '',
    department_id: '',
    chairman_id: '',
    members: [],
};

const InstituteWiseIItmcTeamCreate = (props: any) => {
    const { isOpen, toggle, instituteInfo } = props;
    const [itmcTeamCreate, { isSuccess, isError, error }] = useItmcTeamCreateMutation();
    const [btnClicked, setBtnClicked] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [rowInfo, setRowInfo] = useState<any>(null);
    const [selectedChairman, setSelectedChairman] = useState<any>('');
    const [selectedMembers, setSelectedMembers] = useState<any[]>([]);
    const [selectedSecretaries, setSelectedSecretaries] = useState<any>('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const history = useHistory();

    const { data: instituteList } = useGetOrganizationsQuery();
    const { data: teamInfo } = useGetInstituteWiseItmcTeamInfoQuery(instituteInfo?.id);

    const [selectedInstitute, setSelectedInstitute] = useState<any>('');
    const { data: supervisors } = useGetSupervisorsByInstituteQuery(selectedInstitute ? selectedInstitute.value : '');
    console.log(teamInfo)
    const allInstitute: SelectOption[] =
        instituteList?.data?.map((item) => ({
            value: item.id!,
            label: item.organization_name,
        })) || [];

    const allChairmanMember: SelectOption[] =
        supervisors?.data?.map((item) => ({
            value: item.user_id!,
            label: item.full_name!,
        })) || [];

    const err: CustomError = error as CustomError;

    const {
        handleSubmit,
        getFieldProps,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        resetForm,
        setFieldValue,
        setErrors,
        setValues,
    } = useFormik({
        initialValues,

        validationSchema: Yup.object({
            institute_id: Yup.string().required('Select Institute'),
            committee_name: Yup.string().required('Team Name is required'),
            chairman_id: Yup.string().required('Select Chairman'),
        }),

        onSubmit: (values: any) => {
            console.log(values);
            itmcTeamCreate(values);
        },
    });

    useEffect(() => {
        if (isSuccess) {
            toggle();
            toast.success('Team Created Successfully!');
        }
        if (isError) {
            toast.error(err?.message || 'Something Went Wrong!');
            setFromErrors(err.data, setErrors);
        }
    }, [isSuccess, isError]);

    useEffect(() => {
        if (selectedChairman !== '') {
            setFieldValue('chairman_id', selectedChairman?.value);
        }
    }, [selectedChairman]);

    useEffect(() => {
        if (instituteInfo) {
            setFieldValue('institute_id', instituteInfo?.id);
            setSelectedInstitute({ value: instituteInfo?.id, label: instituteInfo?.organization_name });
        }
    }, [instituteInfo]);

    // Handle member selection (member_type: 'member')
    const handleMember = (selectedOptions: any) => {
        setSelectedMembers(selectedOptions || []);
        updateMembersArray(selectedOptions || [], selectedSecretaries);
    };

    // Handle secretary selection (member_type: 'secretary')
    const handleSecretary = (selectedOptions: any) => {
        setSelectedSecretaries(selectedOptions);
        updateMembersArray(selectedMembers, selectedOptions || '');
    };

    // Update the members array with both members and secretaries
    const updateMembersArray = (members: any[], secretaries: any) => {
        const membersArray: any[] = [];

        // Add members with member_type: 'member'
        members.forEach((member) => {
            membersArray.push({
                member_id: member.value,
                member_type: 'member'
            });
        });

        // Add secretaries with member_type: 'secretary'
        // secretaries.forEach((secretary) => {
        //     membersArray.push({
        //         member_id: secretary.value,
        //         member_type: 'secretary'
        //     });
        // });
        secretaries && membersArray.push({
            member_id: secretaries.value,
            member_type: 'secretary'
        });
        console.log(secretaries);

        // console.log('Updated members array:', membersArray);
        setFieldValue('members', membersArray);
    };

    // Get selected member IDs to filter from available options
    const getSelectedMemberIds = () => {
        const selectedIds = [];
        if (values.chairman_id) selectedIds.push(values.chairman_id);
        selectedMembers.forEach(member => selectedIds.push(member.value));
        // selectedSecretaries.forEach(secretary => selectedIds.push(secretary.value));
        return selectedIds;
    };

    // Filter available options excluding chairman and already selected members/secretaries
    const getAvailableOptions = () => {
        const selectedIds = getSelectedMemberIds();
        return allChairmanMember.filter((option: any) => !selectedIds.includes(option.value));
    };

    const getInstitute = (instituteId: string) => {
        const institute = allInstitute.find(inst => inst.value === instituteId)?.label;
        return institute;
    };


    useEffect(() => {
        if (!isOpen || !teamInfo?.data?.id || isDataLoaded) {
            return;
        }

        if (allInstitute.length === 0) {
            return;
        }

        const instituteOption = allInstitute.find(option => option.value === teamInfo?.data.institute_id);
        if (!instituteOption) {
            return;
        }

        setSelectedInstitute(instituteOption);

        const membersArray: [] = teamInfo?.data?.itmc_team_members?.map((member: any) => ({
            member_id: parseInt(member.member_id),
            member_type: member.member_type
        })) || [];

        setValues({
            itmc_team_id: teamInfo?.data?.id || '',
            committee_name: teamInfo?.data?.committee_name || '',
            institute_id: teamInfo?.data?.institute_id || '',
            department_id: teamInfo?.data?.department_id || '',
            chairman_id: teamInfo?.data?.chairman_id || '',
            members: membersArray || [],
        });

        if (allChairmanMember.length > 0) {
            const members = teamInfo?.data?.itmc_team_members?.filter((member: any) => member?.member_type === 'member') || [];
            const secretaries = teamInfo?.data?.itmc_team_members?.filter((member: any) => member?.member_type === 'secretary') || [];

            const chairmanOption = allChairmanMember.find(option => option.value.toString() === teamInfo?.data.chairman_id);
            setSelectedChairman(chairmanOption || '');

            const selectedMemberOptions = members.map((member: any) =>
                allChairmanMember.find(option => option.value.toString() === member.member_id)
            ).filter(Boolean);
            setSelectedMembers(selectedMemberOptions);

            const selectedSecretaryOption = secretaries.length > 0
                ? allChairmanMember.find(option => option.value.toString() === secretaries[0].member_id)
                : null;
            setSelectedSecretaries(selectedSecretaryOption || null);

            setIsDataLoaded(true);
        }
    }, [isOpen, teamInfo?.data?.id, allInstitute.length, allChairmanMember.length, isDataLoaded]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} size='lg' backdrop={'static'}>
            <ModalHeader toggle={toggle}>Create Team</ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                    onReset={(e) => {
                        resetForm();
                        setSelectedChairman('');
                        setSelectedMembers([]);
                        setSelectedSecretaries([]);
                    }}
                >
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                                <Label for="committee_name" className="form-label required-field">Team Name</Label>
                                <InputField
                                    type="text"
                                    name='committee_name'
                                    placeholder='Team Name'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.committee_name}
                                    invalid={{ errors, touched }}
                                />
                            </FormGroup>
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                                <Label for="institute_id" className="form-label required-field">Institute</Label>
                                <Select
                                    isClearable={true}
                                    isSearchable={true}
                                    value={selectedInstitute}
                                    onChange={setSelectedInstitute}
                                    options={allInstitute}
                                    placeholder='Select Institute'
                                    name="institute_id"
                                    isDisabled
                                />
                            </FormGroup>
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                                <Label for="chairman_id" className="form-label required-field">Chairman</Label>
                                <Select
                                    isClearable={true}
                                    isSearchable={true}
                                    value={selectedChairman}
                                    onChange={setSelectedChairman}
                                    options={allChairmanMember}
                                    placeholder='Select Chairman'
                                    name="chairman_id"
                                />
                                {errors.chairman_id && touched.chairman_id ? (
                                    <div className="text-danger">{errors.chairman_id as string}</div>
                                ) : null}
                            </FormGroup>
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                                <Label for="members">Members</Label>
                                <Select
                                    isClearable={true}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={selectedMembers}
                                    onChange={handleMember}
                                    options={getAvailableOptions()}
                                    placeholder='Select Members'
                                    name="members"
                                />
                            </FormGroup>
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                                <Label for="secretary" className="form-label">Members Secretary</Label>
                                <Select
                                    isClearable={true}
                                    isSearchable={true}
                                    // isMulti={true}
                                    value={selectedSecretaries}
                                    onChange={handleSecretary}
                                    options={getAvailableOptions()}
                                    placeholder='Select Members Secretary'
                                    name="secretary"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <FormGroup className="mb-3 text-center">
                            <Button
                                type="reset"
                                className="btn btn-secondary me-2"
                            >
                                Reset
                            </Button>

                            <button
                                type="submit"
                                className="btn btn-success"
                                onClick={(e) => {
                                    setBtnClicked('submit');
                                }}
                            >
                                Submit
                            </button>
                        </FormGroup>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default InstituteWiseIItmcTeamCreate;